import styled from 'styled-components';

import {
  RewardDescription as DefaultRewardDescription,
  RewardSubtitle as DefaultRewardSubtitle,
} from './external-incentive-details.styled.default';

export * from './external-incentive-details.styled.default';

export const RewardDescription = styled(DefaultRewardDescription)`
  color: ${Styles.color.black};
`;

export const RewardSubtitle = styled(DefaultRewardSubtitle)`
  color: ${Styles.color.black};
`;
